import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import SoldOutBadge from '../ui/SoldOutBadge';

const DesayunosSection = ({ desayunos, openLightbox, openProductDetail, getImageUrl }) => {
  if (desayunos.length === 0) return null;

  return (
    <section id="desayunos" className="py-20 px-6 bg-gradient-to-b from-orange-50 to-cream">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-chocolate mb-4">🥐 Desayunos</h2>
          <p className="text-lg text-chocolate-light max-w-2xl mx-auto">
            Deliciosos desayunos completos y nutritivos para empezar tu día con energía
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {desayunos.map((item) => (
            <Card key={item.id} className={`border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group h-full flex flex-col ${item.available === false ? 'opacity-75' : ''}`}>
              <div
                className="aspect-square overflow-hidden cursor-pointer relative"
                onClick={() => openLightbox(getImageUrl(item.image), item.name)}
              >
                <img
                  src={getImageUrl(item.image)}
                  alt={`${item.name} – Brazolovers, Quito`}
                  loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {item.available === false && <SoldOutBadge />}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <span className="bg-white/90 text-chocolate px-3 py-1 rounded-full text-sm font-medium">
                    🔍 Ver imagen
                  </span>
                </div>
              </div>
              <CardContent className="p-4 space-y-3 flex-grow flex flex-col">
                <h3 className="text-lg font-bold text-chocolate text-center">{item.name}</h3>
                <p className="text-xs text-chocolate-light text-center line-clamp-2">{item.description}</p>
                <div className="flex-grow"></div>
                <div className="text-center">
                  {item.hasOption && <span className="text-xs text-chocolate-light">desde </span>}
                  <span className="text-2xl font-bold text-caramel">${item.price.toFixed(2)}</span>
                </div>
                {item.available === false ? (
                  <Button disabled className="w-full bg-gray-300 text-gray-600 cursor-not-allowed hover:bg-gray-300">
                    Agotado
                  </Button>
                ) : (
                  <Button
                    onClick={() => openProductDetail(item, 'desayuno')}
                    className="w-full bg-[#d4a574] hover:bg-[#c49564] text-white transition-colors duration-200"
                  >
                    Ver Detalles
                  </Button>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DesayunosSection;
